import { createGlobalStyle } from 'styled-components';

export const GlobalStyle =  createGlobalStyle`

body {
  background: #fff;
  margin: 0
  padding: 0;
  font-family:  'Montserrat', sans-serif;
}
a {
  color: #0060B6;
  text-decoration: none;
}
a:hover {
  text-decoration:none;
  cursor:pointer;
}
.text-main{
  color:white;
  background: #d53a23;
}
.bg-transparent{
  background-color: rgb(255,255,255,0.7)!important;
}

.bg-transparent h3{
  position: fixed;
  bottom:50%;
}
.bg-main{
  background: #d53a23;
}
td:hover {
  text-decoration:none;
  cursor:pointer;
}

  /* width */
div ::-webkit-scrollbar {
  width: 15px;
  height: 15px;
}

/* Track */
div ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 5px;
}

/* Handle */
div ::-webkit-scrollbar-thumb {
  background: #d53a23;
  border-radius: 7px;
}
`
